export const LEVEL_COLORS = ['#348e38', '#2b78e4', '#ff9900', '#cf2a27', '#ff00ff'];
